import axiosInstance from "../Shared/Utils/axiosInstance";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
export const getAnmProfileFromServer = async (selectedLanguageID, anmId) => {
  try {
    const response = await axiosInstance.get(
      `/api/getANMProfile/${selectedLanguageID}/${anmId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch ASHA profile"
    );
  }
};
export const getSubcenterList = async (selectedLanguageId, anmId) => {
  try {
    const response = await axiosInstance.get(
      `/api/fetchSubcenters/${selectedLanguageId}/${anmId}`
    );
    return TokenDecrypt(response.data.data);
  } catch (error) {
    return [];
  }
};
